function parseTime(time) {
  const value = Number.parseFloat(time);

  if (Number.isNaN(value)) {
    return 0;
  }

  return time.trim().endsWith('ms') ? value : value * 1000;
}

function transitionTimeout(element) {
  const style = window.getComputedStyle(element);
  const durations = style.transitionDuration.split(',').map(parseTime);
  const delays = style.transitionDelay.split(',').map(parseTime);

  return durations.reduce((longest, duration, index) => {
    const delay = delays[index] ?? delays[delays.length - 1] ?? 0;
    return Math.max(longest, duration + delay);
  }, 0);
}

export function waitForTransition(element) {
  const timeout = transitionTimeout(element);

  if (timeout === 0) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    let timer;

    const finish = () => {
      window.clearTimeout(timer);
      element.removeEventListener('transitionend', handleTransitionEnd);
      resolve();
    };

    const handleTransitionEnd = (event) => {
      if (event.target === element) {
        finish();
      }
    };

    element.addEventListener('transitionend', handleTransitionEnd);
    timer = window.setTimeout(finish, timeout + 50);
  });
}
